import { isEmptyDocument } from 'lib-knowledge-document-structure';
import {
  isCollapsed,
  isElementEmpty,
} from 'lib-knowledge-document-structure/plate/common';
import { useMyEditorState } from 'lib-knowledge-document-structure/plateHooks';
import {
  MyBlock,
  MyListItemElement,
} from 'lib-knowledge-document-structure/plateTypes';
import { Text as SlateText } from 'lib-knowledge-document-structure/slate/package';
import {
  useFocused,
  useSelected,
} from 'lib-knowledge-document-structure/slate/react';

function usePlaceholder({
  placeholder,
  element,
}: {
  placeholder: string;
  element: MyBlock;
}): string | undefined {
  const focused = useFocused();
  const selected = useSelected();
  const editor = useMyEditorState();

  // Don't show placeholder if article is empty because Plate will show it's one
  const isEmptyArticle = isEmptyDocument(editor.children);
  if (isEmptyArticle) return undefined;

  const isEmptyBlock =
    element.type === 'li'
      ? isLiElementIsEmpty(element as unknown as MyListItemElement)
      : isElementEmpty(editor, element);

  const enabled =
    isEmptyBlock && isCollapsed(editor.selection) && focused && selected;

  return enabled ? placeholder : undefined;
}

// Because li elements have lic elements as children.
function isLiElementIsEmpty(element: MyListItemElement): boolean {
  const { children } = element;
  if (children.length > 1) return false;
  if (children.length === 0) return true;
  if (children[0].type !== 'lic') return false;
  if (children[0].children.length > 1) return false;
  if (children[0].children.length === 0) return true;
  const [firstChild] = children[0].children;
  return SlateText.isText(firstChild) && firstChild.text === '';
}

export default usePlaceholder;
